import { Box } from '@mui/material';

// WCAG 2.4.1 (Bypass Blocks). Visually hidden until focused; the first Tab on
// any page reveals it and jumps focus to the <main> landmark (#main-content).
const SkipLink = () => (
  <Box
    component="a"
    href="#main-content"
    sx={{
      position: 'absolute',
      left: 8,
      top: -80,
      zIndex: (theme) => theme.zIndex.tooltip + 1,
      px: 2,
      py: 1,
      borderRadius: 1,
      backgroundColor: '#FFFFFF',
      color: 'brandDarkBlue',
      fontWeight: 700,
      fontSize: 16,
      textDecoration: 'none',
      boxShadow: 3,
      transition: 'top 0.15s ease-in',
      '&:focus, &:focus-visible': { top: 8 },
    }}
  >
    Skip to main content
  </Box>
);

export default SkipLink;
